import { ref, computed } from "vue";
import { defineStore } from "pinia";
import type { IChatMessage } from "../interfaces/chatBotInterfaces";

export const useChatBotStore = defineStore("chatBot", () => {
  const messages = ref<Array<IChatMessage>>([]);

  const messageCount = computed(() => messages.value.length);

  const isChatOpen = ref(false);

  const clearHistory = () => {
    if (confirm("Are you sure you want to clear the chat history?")) {
      messages.value = [];
    }
  };

  function toggleChat() {
    isChatOpen.value = !isChatOpen.value;
  }

  return { messages, messageCount, isChatOpen, clearHistory, toggleChat };
});
